import { useState } from 'react'
import { createPortal } from 'react-dom'
import { X, Plus } from 'lucide-react'

const MAX_OPTIONS = 12

/** Anket oluşturma penceresi — soru + 2..12 seçenek + çoklu/gizli. */
export default function PollComposerModal({ onClose, onSubmit }) {
  const [q, setQ] = useState('')
  const [opts, setOpts] = useState(['', ''])
  const [multi, setMulti] = useState(false)
  const [anon, setAnon] = useState(false)
  const [busy, setBusy] = useState(false)

  const valid = q.trim() && opts.filter((o) => o.trim()).length >= 2

  return createPortal(
    <div className="fixed inset-0 z-[95] bg-black/40 flex items-center justify-center p-4"
      onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-5"
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-[15px] font-bold text-gray-900">Anket oluştur</h3>
          <button onClick={onClose} className="p-1 rounded-lg text-gray-400 hover:bg-gray-100"><X size={16} /></button>
        </div>

        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Soru"
          className="w-full px-3 py-2 mb-3 text-sm border border-gray-200 rounded-lg outline-none focus:border-primary-400" />

        {opts.map((o, i) => (
          <div key={i} className="flex items-center gap-2 mb-2">
            <input value={o} placeholder={`Seçenek ${i + 1}`}
              onChange={(e) => setOpts((p) => p.map((x, j) => (j === i ? e.target.value : x)))}
              className="flex-1 px-3 py-2 text-sm border border-gray-200 rounded-lg outline-none focus:border-primary-400" />
            {/* En az 2 seçenek kalmalı */}
            {opts.length > 2 && (
              <button onClick={() => setOpts((p) => p.filter((_, j) => j !== i))}
                className="p-1.5 rounded-lg text-gray-400 hover:text-red-600 hover:bg-red-50"><X size={14} /></button>
            )}
          </div>
        ))}
        {opts.length < MAX_OPTIONS && (
          <button onClick={() => setOpts((p) => [...p, ''])}
            className="inline-flex items-center gap-1 text-[12.5px] text-primary-600 hover:underline mb-3">
            <Plus size={13} /> Seçenek ekle
          </button>
        )}

        <label className="flex items-center gap-2 text-[13px] text-gray-700 mb-1.5">
          <input type="checkbox" checked={multi} onChange={(e) => setMulti(e.target.checked)} />
          Birden fazla seçilebilsin
        </label>
        <label className="flex items-center gap-2 text-[13px] text-gray-700 mb-4">
          <input type="checkbox" checked={anon} onChange={(e) => setAnon(e.target.checked)} />
          Gizli oy <span className="text-gray-400 text-[11.5px]">(kimin ne oyladığı görünmez)</span>
        </label>

        <button disabled={!valid || busy}
          onClick={async () => {
            setBusy(true)
            try {
              await onSubmit?.({
                question: q.trim(),
                options: opts.map((o) => o.trim()).filter(Boolean),
                multi, anonymous: anon,
              })
            } finally { setBusy(false) }
          }}
          className="w-full py-2 rounded-lg bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 disabled:opacity-40">
          {busy ? 'Gönderiliyor…' : 'Anketi gönder'}
        </button>
      </div>
    </div>,
    document.body,
  )
}
